"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { capturePostHogPageView } from "@/lib/analytics/posthog-config";

export default function PostHogPageView() {
  const pathname = usePathname();
  const postHog = usePostHog();

  useEffect(() => {
    if (pathname) {
      capturePostHogPageView(postHog, window.location.origin, pathname);
    }
  }, [pathname, postHog]);

  return null;
}
